import React from 'react';
import PropTypes from 'prop-types';

import SmartChart from '../../../../components/Chart/SmartChart';

import config from './config';

const metaSeriesData = {
  monetization: { name: ' ', type: 'pie' },
};

const MonetizationPie = ({ series }) => (
  <SmartChart
    className="publisher_page_monetization__pie d-flex justify-content-center"
    series={{ monetization: series }}
    metaSeriesData={metaSeriesData}
    config={config}
  />
);

MonetizationPie.propTypes = {
  series: PropTypes.array.isRequired,
};

export default MonetizationPie;
